window.addEventListener('tiv:analytics', (e) => {
  const { event: gtmEvent, ...d } = e.detail;
  const paramMap = EVENT_MAP[gtmEvent];

  if (!paramMap) {
    // Datadog: custom monitoring log
    window.DD_LOGS?.logger?.error('[TIV] Unknown analytics event', { gtmEvent });
    return;
  }

  sendToGTM(gtmEvent, resolveParams(paramMap, d));
});

function sendToGTM(eventName, params) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
}

// Helpers
function resolveParams(paramMap, d) {
  return Object.fromEntries(
    Object.entries(paramMap).map(([key, fn]) => [key, fn(d)])
  );
}

const getDeviceType = () =>
  /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop';

const calcAdjustmentDirection = (original, adjusted) =>
  adjusted < original ? 'down' : 'up';

const calcAdjustmentPercentage = (original, adjusted) =>
  original ? parseFloat((Math.abs((adjusted - original) / original) * 100).toFixed(2)) : null;

// Events mapping
const EVENT_MAP = {
  tiv_search_viewed: {
    source:      (d) => d.source || 'direct',
    device_type: () => getDeviceType(),
  },

  tiv_search_lookup_attempted: {
    has_email:     (d) => d.has_email,
    has_ps_number: (d) => d.has_ps_number,
  },

  tiv_search_lookup_success: {
    ps_number:  (d) => d.ps_number,
    item_count: (d) => d.item_count,
  },

  tiv_search_lookup_error: {
    ps_number:  (d) => d.ps_number,
    error_type: (d) => d.error_type,
  },

  tiv_box_status_viewed: {
    ps_number:   (d) => d.ps_number,
    box_status:  (d) => d.box_status,
    item_count:  (d) => d.item_count,
    device_type: () => getDeviceType(),
  },

  tiv_item_status_viewed: {
    ps_number:      (d) => d.ps_number,
    item_id:        (d) => d.item_id,
    item_name:      (d) => d.item_name,
    item_status:    (d) => d.item_status,
    has_adjustment: (d) => d.has_adjustment,
  },
  
  tiv_item_offer_change_confirm_selected: {
    ps_number:             (d) => d.ps_number,
    item_id:               (d) => d.item_id,
    original_offer:        (d) => d.original_offer,
    adjusted_offer:        (d) => d.adjusted_offer,
    adjustment_direction:  (d) => calcAdjustmentDirection(d.original_offer, d.adjusted_offer),
    adjustment_percentage: (d) => calcAdjustmentPercentage(d.original_offer, d.adjusted_offer),
  },

  tiv_item_offer_change_return_selected: {
    ps_number:             (d) => d.ps_number,
    item_id:               (d) => d.item_id,
    original_offer:        (d) => d.original_offer,
    adjusted_offer:        (d) => d.adjusted_offer,
    adjustment_direction:  (d) => calcAdjustmentDirection(d.original_offer, d.adjusted_offer),
    adjustment_percentage: (d) => calcAdjustmentPercentage(d.original_offer, d.adjusted_offer),
  },

  tiv_item_offer_change_submitted: {
    ps_number:             (d) => d.ps_number,
    item_id:               (d) => d.item_id,
    decision_made:         (d) => d.decision_made,
    original_offer:        (d) => d.original_offer,
    adjusted_offer:        (d) => d.adjusted_offer,
    adjustment_direction:  (d) => calcAdjustmentDirection(d.original_offer, d.adjusted_offer),
    adjustment_percentage: (d) => calcAdjustmentPercentage(d.original_offer, d.adjusted_offer),
  },
};